import { getTimeInSeconds } from 'utils/times/getTimeInSeconds';
export function isStartTimeBeforeEndTime(startTime, endTime) {
  var startTimeInSeconds = getTimeInSeconds(startTime);
  var endTimeInSeconds = getTimeInSeconds(endTime);
  if (startTimeInSeconds === null || endTimeInSeconds === null) {
    return true;
  }
  return endTimeInSeconds > startTimeInSeconds;
}